export default __webpack_public_path__ + "static/media/info.a1a57662.png";